import { sessionStorage } from '@fiverr-private/futile';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { AUTO_SHOWN_KEY, PAGE_VIEW_INCREASED_THRESHOLD, PAGE_VIEW_THRESHOLD } from './constants';
import { legacyPageViewTracker } from './tracker';

interface IsAutoShowEligibleProps {
    autoShowSignUpEnabled: boolean;
    pageViews: number;
    threshold: number;
}

export const handleAutoShowSignUp = ({ autoShowSignUpEnabled = true }) => {
    const pageViews = legacyPageViewTracker.track();
    const { isMobile } = getContext();

    return isAutoShowEligible({
        autoShowSignUpEnabled,
        pageViews,
        threshold: isMobile ? PAGE_VIEW_THRESHOLD : PAGE_VIEW_INCREASED_THRESHOLD,
    });
};

const isAutoShowEligible = ({ autoShowSignUpEnabled, pageViews, threshold }: IsAutoShowEligibleProps) => {
    const { userId } = getContext();
    const reachedPageViewThreshold = pageViews === threshold;
    const isShown = sessionStorage.get(AUTO_SHOWN_KEY);

    return !userId && autoShowSignUpEnabled && reachedPageViewThreshold && !isShown;
};

export const setAutoShown = () => {
    sessionStorage.set(AUTO_SHOWN_KEY, true).catch((error) =>
        logger.warn(error, {
            description: 'Failed setting auto shown sign up key',
        })
    );
};
